package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class NoteRevisionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectByNote(note_id: String, mapper: (
    id: String,
    note_id: String,
    title: String?,
    body: String,
    created_at: Long,
    kept_at: Long,
  ) -> T): Query<T> = SelectByNoteQuery(note_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!
    )
  }

  public fun selectByNote(note_id: String): Query<Note_revision> = selectByNote(note_id) { id,
      note_id_, title, body, created_at, kept_at ->
    Note_revision(
      id,
      note_id_,
      title,
      body,
      created_at,
      kept_at
    )
  }

  public fun deleteByNote(note_id: String) {
    driver.execute(1_642_024_635, """DELETE FROM note_revision WHERE note_id = ?""", 1) {
          bindString(0, note_id)
        }
    notifyQueries(1_642_024_635) { emit ->
      emit("note_revision")
    }
  }

  public fun keep(
    note_id: String,
    title: String?,
    body: String,
    created_at: Long,
    kept_at: Long,
  ) {
    driver.execute(-906_805_556, """
        |INSERT INTO note_revision(id, note_id, title, body, created_at, kept_at)
        |VALUES (lower(hex(randomblob(8))), ?, ?, ?, ?, ?)
        """.trimMargin(), 5) {
          bindString(0, note_id)
          bindString(1, title)
          bindString(2, body)
          bindLong(3, created_at)
          bindLong(4, kept_at)
        }
    notifyQueries(-906_805_556) { emit ->
      emit("note_revision")
    }
  }

  private inner class SelectByNoteQuery<out T : Any>(
    public val note_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("note_revision", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("note_revision", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(147_946_828,
        """SELECT note_revision.id, note_revision.note_id, note_revision.title, note_revision.body, note_revision.created_at, note_revision.kept_at FROM note_revision WHERE note_id = ? ORDER BY kept_at DESC""",
        mapper, 1) {
      bindString(0, note_id)
    }

    override fun toString(): String = "NoteRevision.sq:selectByNote"
  }
}
